export default __webpack_public_path__ + "static/media/welcome.89d33bb6.png";